import React from "react";
import { FaGithub, FaLinkedin, FaEnvelope, FaInstagram, FaFacebook } from "react-icons/fa";
import ProfileImage from "../assets/Images/image2_cv.jpg"; // Replace with your correct image path

const Profile = () => {
  return (
    <section className="bg-gradient-to-b from-gray-900 to-gray-800 text-white py-20">
      <div className="max-w-7xl mx-auto px-6 lg:px-16 flex flex-col lg:flex-row items-center lg:items-start gap-16">
        {/* Left Section: Image */}
        <div
          data-aos="fade-right"
          className="relative flex flex-col items-center lg:w-1/3"
        >
          <div className="relative w-48 h-64 lg:w-60 lg:h-80">
            {/* Gradient Rectangular Frame */}
            <div
              className="absolute inset-0 rounded-lg shadow-lg border-4"
              style={{ borderColor: "rgb(249, 115, 22)" }}
            ></div>
            <img
              src={ProfileImage}
              alt="Azzeddine Imali"
              className="w-full h-full object-cover border-4 border-gray-800 rounded-lg shadow-2xl transform transition-all duration-500 hover:scale-105 hover:shadow-2xl"
              onError={(e) => {
                e.target.onerror = null;
                e.target.src =
                  "https://via.placeholder.com/150?text=No+Image"; // Placeholder in case of error
              }}
            />
          </div>

          {/* Social Handles Below Image */}
          <div className="mt-8 flex gap-4">
            <a
              href="https://github.com/azedin"
              target="_blank"
              rel="noopener noreferrer"
              className="text-3xl p-3 bg-gray-800 hover:bg-orange-500 text-white rounded-full transition duration-300"
            >
              <FaGithub />
            </a>
            <a
              href="https://www.linkedin.com/in/imaliazzeddine/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-3xl p-3 bg-gray-800 hover:bg-blue-500 text-white rounded-full transition duration-300"
            >
              <FaLinkedin />
            </a>
            <a
              href="mailto:imaliazedin@gmail.com"
              className="text-3xl p-3 bg-gray-800 hover:bg-teal-500 text-white rounded-full transition duration-300"
            >
              <FaEnvelope />
            </a>
            <a
              href="https://www.instagram.com/im1zdn_/profilecard/?igsh=cnZzd2VobmowcGZ3"
              target="_blank"
              rel="noopener noreferrer"
              className="text-3xl p-3 bg-gray-800 hover:bg-pink-500 text-white rounded-full transition duration-300"
            >
              <FaInstagram />
            </a>
            <a
              href="https://www.facebook.com/share/1Xf8wwX1Sa/?mibextid=LQQJ4d"
              target="_blank"
              rel="noopener noreferrer"
              className="text-3xl p-3 bg-gray-800 hover:bg-blue-600 text-white rounded-full transition duration-300"
            >
              <FaFacebook />
            </a>
          </div>
        </div>

        {/* Right Section: Text Content */}
        <div
          data-aos="fade-left"
          className="lg:w-2/3 text-center lg:text-left space-y-6"
        >
          <h1 className="text-4xl md:text-5xl font-bold">
            Hello, I’m <span className="text-orange-500">Azzeddine Imali</span>
          </h1>
          <p className="text-lg leading-relaxed mt-4">
            I am an experienced <span className="font-semibold">IT Engineer</span> and <span className="font-semibold">AI Specialist</span> with expertise in IT infrastructure management, network administration, and digital transformation initiatives. With over four years of experience in both public and private sectors, I excel in designing scalable and secure solutions aligned with organizational objectives.
          </p>
          <p className="text-lg leading-relaxed">
            At the <span className="font-semibold">Ministry of Equipment and Water</span>, I contributed to national cybersecurity policies while ensuring the efficiency and security of critical IT systems. At <span className="font-semibold">ALTEN MAROC</span>, I supported advanced telecommunications systems and resolved high-level enterprise challenges.
          </p>
          <p className="text-lg leading-relaxed">
            My solid academic foundation in <span className="font-semibold">databases</span>, <span className="font-semibold">information systems</span>, <span className="font-semibold">big data</span>, and <span className="font-semibold">cybersecurity</span> complements my practical experience, enabling me to deliver innovative and impactful IT solutions.
          </p>

          {/* Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start mt-6">
            <a
              href="#contact"
              className="bg-orange-500 text-white py-3 px-8 rounded-full text-md font-medium border-2 border-orange-500 hover:bg-gray-200 hover:text-black hover:border-orange-500 transition"
            >
              Hire Me
            </a>
            <a
              href="https://drive.google.com/file/d/1mEJEWJryWX77Nsxp4m3SNlBEqumXD4xX/view?usp=sharing"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-gray-800 text-white py-3 px-8 rounded-full text-md font-medium border-2 border-gray-700 hover:bg-gray-200 hover:text-black hover:border-teal-400 transition"
            >
              Download Resume
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Profile;
